<template>
  <div class="container-fluid">
    <div class="contents membership">
      <tab />

      <div class="locker_title row g-0">
        <div class="col-lg d-flex align-items-stretch bg-gray border-right">
          <h6 class="my-auto flex-fill py-2">
            {{ $t("title.membership.locker_status") }}
          </h6>
        </div>
        <div
          class="col-lg d-flex flex-wrap justify-content-evenly align-items-stretch border-right"
        >
          <div class="flex-fill my-auto">
            <span class="available"></span>
            <p>{{ $t("title.membership.available") }}</p>
          </div>
          <div class="flex-fill my-auto">
            <span class="unavailable"></span>
            <p>{{ $t("title.membership.unavailable") }}</p>
          </div>
          <div class="flex-fill my-auto">
            <span class="expired"></span>
            <p>{{ $t("title.membership.expired") }}</p>
          </div>
          <div class="flex-fill my-auto">
            <span class="using"></span>
            <p>{{ $t("title.membership.using") }}</p>
          </div>
        </div>
        <div class="col-lg">
          <a @click="prev_pageno">{{ $t("button.membership.prev") }}</a>
          <select class="" v-model="pageno" @change="change_pageno">
            <option v-for="(item, idx) in pagenoOptCnt" :key="idx">
              {{ item }}
            </option>
          </select>
          <a @click="next_pageno">{{ $t("button.membership.next") }}</a>
        </div>
      </div>

      <div class="locker-room-wrapper mt-4">
        <div
          class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 row-cols-xxl-5 g-2"
          v-if="lockerinfo.length > 0"
        >
          <div class="col" v-for="(item, idx) in lockerinfo" :key="idx">
            <div
              class="locker-room"
              :class="{
                using: lockerStatus(lockerinfo[idx]) === 1,
                expired: lockerStatus(lockerinfo[idx]) === 2,
                unavailable: lockerStatus(lockerinfo[idx]) === 3,
                lockerBg: lockerinfo[idx].lockerBg,
              }"
              @click="lockerSelect(idx)"
            >
              <div
                v-html="lockerShowText(idx)"
                :class="{
                  in:
                    lockerStatus(lockerinfo[idx]) === 1 ||
                    lockerStatus(lockerinfo[idx]) === 2 ||
                    lockerStatus(lockerinfo[idx]) === 3,
                }"
              ></div>

              <!-- 미사용 -->
              <div
                :ref="`pop0_${idx}`"
                class="in visually-hidden"
                v-if="lockerStatus(lockerinfo[idx]) === 0"
              >
                <button @click="lockerStatusChange(idx, 1)">
                  {{ $t("button.membership.unavailable") }}
                </button>
              </div>

              <!-- 사용중 -->
              <div
                :ref="`pop1_${idx}`"
                class="in2 visually-hidden"
                v-if="lockerStatus(lockerinfo[idx]) === 1"
              >
                <button @click="lockerDetail(idx, lockerinfo[idx].playerno)">
                  {{ $t("button.membership.info") }}
                </button>
                <button @click="lockerStatusChange(idx, 2)">
                  {{ $t("button.common.cancel") }}
                </button>
              </div>

              <!-- 기간만료 -->
              <div
                :ref="`pop2_${idx}`"
                class="in2 visually-hidden"
                v-if="lockerStatus(lockerinfo[idx]) === 2"
              >
                <button @click="lockerDetail(idx, lockerinfo[idx].playerno)">
                  {{ $t("button.membership.info") }}
                </button>
                <button @click="lockerStatusChange(idx, 2)">
                  {{ $t("button.common.cancel") }}
                </button>
              </div>

              <!-- 사용불가 -->
              <div
                :ref="`pop3_${idx}`"
                class="in visually-hidden"
                v-if="lockerStatus(lockerinfo[idx]) === 3"
              >
                <button @click="lockerStatusChange(idx, 0)">
                  {{ $t("button.membership.available") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="p-5 lh-sm text-center text-black">
          <div class="d-flex justify-content-center">
            <p class="mb-3 icon-box rounded-circle bg-orange">
              <span class="material-icons-round text-white"
                >app_registration</span
              >
            </p>
          </div>
          {{ $t("text.membership.register_locker") }}<br>
          {{ $t("text.common.contact_admin") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/member";
import "@/filter/common";
import tab from "@/components/member/Tab";

export default {
  name: "LockerView",
  components: {
    tab,
  },
  data() {
    return {
      lockerinfocnt: 0,
      lockerinfo: [
        {
          no: null,
          lockerno: null,
          lockerstatus: null, // 0: 사용가능, 1: 사용중, 2: 기간만료, 3: 사용불가
          playerno: null,
        },
      ],
      lockerSelected: null,
      pageno: this.$route.query.pageno || 1,
      pagesize: 30,
      pagenoOptCnt: 0,
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      ax.lockerGet2(this.pageno, (response) => {
        this.lockerinfo = [];
        this.lockerinfocnt = response.lockerinfocnt;
        for (let i = 0; i < response.lockerinfo.length; i++) {
          response.lockerinfo[i].lockerBg = false;
          this.lockerinfo.push(response.lockerinfo[i]);
        }
        // 페이지수 계산
        this.pagenoOptCnt = Math.ceil(response.lockerinfocnt / this.pagesize);
      });
    },
    lockerSelect(idx) {
      if (this.lockerinfo[idx]) {
        let lidx = parseInt(this.lockerinfo[idx].lockerstatus);

        this.$refs["pop" + lidx + "_" + idx][0].classList.toggle(
          "visually-hidden"
        );
        console.log(this.lockerinfo[idx].lockerBg);
        for (let i in this.lockerinfo) {
          let lidx = parseInt(this.lockerinfo[i].lockerstatus);
          if (this.lockerinfo[i].lockerBg === true) {
            this.$refs["pop" + lidx + "_" + i][0].classList.add(
              "visually-hidden"
            );
            // this.lockerinfo[i].lockerBg = false;
          }
        }
        for (let i in this.lockerinfo) {
          this.lockerinfo[i].lockerBg = false;
        }
        // // 선택한거 bg-info 넣기
        this.lockerinfo[idx].lockerBg = true;
      }
    },
    lockerStatus(o) {
      if (o) {
        return parseInt(o.lockerstatus);
      }
    },
    lockerShowText(idx) {
      if (this.lockerinfo[idx]) {
        if (parseInt(this.lockerinfo[idx].lockerstatus) === 1 || parseInt(this.lockerinfo[idx].lockerstatus) === 2) {
          return (
            "<div>" +
            '<span class="number">' +
            this.lockerinfo[idx].lockerno +
            "</span>" +
            '<span class="text-nickname">' +
            this.lockerinfo[idx].nickname +
            "</span>" +
            "</div>" +
            '<div class="text-date">' +
            this.$dayjs(this.lockerinfo[idx].timezone_enddate).format(
              "YYYY-MM-DD"
            ) +
            "</div>"
          );
        }
      }
      return this.lockerinfo[idx].lockerno;
    },
    lockerStatusChange(idx, status) {
      console.log(1111);
      ax.lockerStatus(
        this.lockerinfo[idx].lockerno,
        status,
        (flag, response) => {
          if (flag) {
            // this.$notify({
            //   group: "alert",
            //   type: "info",
            //   title: "Information",
            //   text: this.$i18n.t("alert.member.locker_information_corrected"),
            // });
            this.init();
          }
        }
      );
    },
    lockerDetail(idx, playerno = null) {
      this.$router.push({ name: "MemberView", params: { playerno: playerno } }); // todo::// player no없음 다시 처리 필요
    },
    change_pageno() {
      this.$router.push({ query: { pageno: this.pageno } });
    },
    prev_pageno() {
      if (this.pageno > 1) {
        this.pageno = parseInt(this.pageno) - 1;
        this.$router.push({ query: { pageno: this.pageno } });
      }
    },
    next_pageno() {
      if (this.pageno < this.pagenoOptCnt) {
        this.pageno = parseInt(this.pageno) + 1;
        this.$router.push({ query: { pageno: this.pageno } });
      }
    },
  },
  watch: {
    "$route.query": function () {
      this.init();
    },
  },
};
</script>